// extracted by css-extract-rspack-plugin
export default {"nav":"MarketingNavigation-module__nav__W0KYY","list":"MarketingNavigation-module__list__tFbMb","navLink":"MarketingNavigation-module__navLink__hUomM"};